<template>
  <div class="about" style="width:100%;height:100%;background-image:url('/assets/hero-cars-top-right.png');background-position:bottom right;background-size:cover;">
    <h1>This is an about page!</h1>
  </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    mounted: function(){
      //this.$store.dispatch('fetchUsers')
    }
}
</script>
